var _g, _path, _path2, _rect, _path3, _path4, _path5, _path6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _rect2, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect15, _rect16, _ellipse5, _ellipse6, _ellipse7, _path20, _rect17, _rect18, _rect19, _path21, _path22, _rect20, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse8, _ellipse9, _ellipse10, _path29, _path30, _path31, _ellipse11, _ellipse12, _path32, _ellipse13, _ellipse14, _path33, _path34, _path35, _path36, _path37, _path38, _ellipse15, _path39, _path40, _path41, _ellipse16, _path42, _path43, _path44, _path45, _path46, _path47, _rect21, _rect22, _path48, _path49, _rect23, _path50, _ellipse17, _path51, _ellipse18, _path52, _ellipse19, _path53, _ellipse20, _path54, _ellipse21, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFte2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6495 427.787C84.6495 427.787 -6.10441 319.851 21.0815 292.227C48.2673 264.603 93.9567 294.756 86.1302 263.97C78.3037 233.185 47.1186 203.321 59.7212 179.958C74.8493 151.917 119.117 174.669 140.554 184.488C180.407 202.744 224.571 204.769 209.266 179.238C193.961 153.707 153.892 128.761 168.426 114.21C188.204 94.4095 296.963 167.708 343.51 225.107C371.367 259.46 391.671 235.556 388.85 213.487C387.057 199.459 367.325 170.514 388.024 157.413C407.978 144.785 454.579 183.919 470.409 208.082C511.859 271.353 443.994 427.172 443.994 427.172L84.6495 427.787Z",
    fill: "#C5CEDA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.445 128.993H264.066V76.4648H157.445V128.993ZM263.312 128.241H158.202V77.2165H263.312V128.241Z",
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.679,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.912,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.145,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.379,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.612,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.845,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.079,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.822,
    y: 117.882,
    width: 105.865,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.822,
    y: 107.527,
    width: 105.865,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.822,
    y: 97.1711,
    width: 105.865,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.822,
    y: 86.817,
    width: 105.865,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.056 128.993H130.979V76.4619H171.056V77.2165H131.735V128.239H171.056V128.993V128.993Z",
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.212,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.444,
    y: 76.8397,
    width: 0.755858,
    height: 51.7768,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.357,
    y: 117.882,
    width: 39.6985,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.357,
    y: 107.527,
    width: 39.6985,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.357,
    y: 97.1711,
    width: 39.6985,
    height: 0.755647,
    fill: "#8896AA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.357,
    y: 86.817,
    width: 39.6985,
    height: 0.755647,
    fill: "#8896AA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.692 139.74L180.963 139.545L183.957 128.396L184.056 128.318L197.393 117.882H210.626L223.86 107.527H237.354L237.457 107.609L250.458 117.934L303.258 76.6168H316.491L329.622 66.3406L330.088 66.9363L316.751 77.3714H303.518L250.455 118.896L237.091 108.282H224.119L210.885 118.638H197.653L184.621 128.835L181.692 139.74V139.74Z",
    fill: "url(#paint0_linear_55_20737)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.027 178.029V232.193H123.033V131.042H262.027V178.029",
    fill: "#E1E1E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 139.28,
    y: 147.021,
    width: 123.013,
    height: 8.68594,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262.028 138.466V147.021H123.033V131.044H262.028V138.466",
    fill: "#4A90E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.457 130.351H139.014V232.196H123.033V130.351H130.457",
    fill: "#055CC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.522 233.706H264.479V128.84H121.522V233.706ZM261.456 230.685H124.544V131.862H261.456V230.685Z",
    fill: "#0134A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.522 233.706H264.479V128.84H121.522V233.706ZM261.456 230.685H124.544V131.862H261.456V230.685Z",
    fill: "#0134A0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.024,
    cy: 157.499,
    rx: 3.95426,
    ry: 3.95315,
    fill: "#E6E6E8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.024,
    cy: 169.86,
    rx: 3.95426,
    ry: 3.95315,
    fill: "#E6E6E8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.024,
    cy: 182.221,
    rx: 3.95426,
    ry: 3.95315,
    fill: "#8896AA"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.024,
    cy: 194.583,
    rx: 3.95426,
    ry: 3.95315,
    fill: "#E6E6E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 163.557,
    width: 106.654,
    height: 10.4311,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 173.988,
    width: 106.654,
    height: 10.4311,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 184.326,
    width: 106.654,
    height: 10.4311,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 194.758,
    width: 106.654,
    height: 10.4311,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 205.081,
    width: 106.654,
    height: 10.4311,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M179.239 205.566H157.908V204.812H179.085L189.64 194.489H190.169L200.568 204.661L221.635 184.15L221.896 184.043L232.41 183.95L253.632 163.287L254.16 163.827L232.829 184.596L232.568 184.703L222.054 184.796L200.833 205.46H200.304L189.904 195.286L179.503 205.46L179.239 205.566V205.566Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M222.163 215.784H221.638L211.08 205.565L189.988 205.315L189.733 205.212L179.243 195.282L158.173 215.783L157.646 215.242L178.976 194.489L179.5 194.484L190.144 204.561L211.239 204.812L211.498 204.918L221.9 214.987L232.303 204.918L232.829 205.461L222.163 215.784V215.784Z",
    fill: "#055CC0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M242.968 215.784L210.801 184.703H200.415L189.751 174.366H179.392L168.728 184.702L157.911 184.798L157.905 184.042L168.418 183.95L179.085 173.61H190.058L200.722 183.949H211.107L211.218 184.054L243.493 215.241L242.968 215.784V215.784Z",
    fill: "#4A90E2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 147.243,
    y: 163.557,
    width: 10.544,
    height: 51.9547,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 148.227,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 158.891,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 169.558,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 180.223,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 190.888,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 201.553,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 212.219,
    y: 219.752,
    width: 8.69836,
    height: 2.3459,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.865 215.89H254.275V163.179H146.865V215.89ZM253.52 215.135H147.622V163.935H253.52V215.135Z",
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.671 216.478C182.678 216.579 182.627 216.675 182.54 216.726C182.5 216.772 182.448 216.806 182.39 216.826L176.999 218.235L174.985 223.441C174.917 223.595 174.764 223.694 174.596 223.691C174.431 223.682 174.292 223.568 174.25 223.409L170.75 211.756C170.718 211.617 170.765 211.473 170.872 211.38C170.979 211.287 171.129 211.261 171.261 211.313L182.459 216.11C182.606 216.169 182.694 216.321 182.671 216.478V216.478Z",
    fill: "#0134A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.611 164.933C185.608 162.988 184.671 161.163 183.093 160.025C181.514 158.888 179.485 158.578 177.639 159.191C175.752 159.795 174.296 161.307 173.764 163.214C173.082 165.537 173.854 168.042 175.725 169.578C176.972 170.66 177.914 172.049 178.456 173.608L178.63 174.07C178.774 174.465 179.15 174.729 179.57 174.729C179.991 174.729 180.367 174.465 180.51 174.07L180.792 173.319C181.411 171.801 182.384 170.455 183.63 169.391C184.893 168.253 185.613 166.633 185.611 164.933V164.933Z",
    fill: "#055CC0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M179.567 162.266C178.093 162.266 176.898 163.46 176.898 164.933C176.898 166.407 178.093 167.601 179.567 167.601C181.041 167.601 182.235 166.407 182.235 164.933C182.235 164.226 181.954 163.547 181.454 163.047C180.953 162.547 180.275 162.266 179.567 162.266Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.679 175.146C216.676 173.2 215.74 171.375 214.161 170.238C212.582 169.101 210.553 168.79 208.707 169.403C206.82 170.007 205.363 171.519 204.831 173.427C204.15 175.749 204.922 178.254 206.792 179.792C208.039 180.873 208.981 182.262 209.525 183.821L209.697 184.282C209.841 184.678 210.217 184.942 210.638 184.942C211.059 184.942 211.435 184.678 211.578 184.282L211.86 183.531C212.478 182.013 213.451 180.667 214.699 179.604C215.961 178.465 216.681 176.845 216.679 175.146V175.146Z",
    fill: "#055CC0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M210.635 172.478C209.162 172.478 207.967 173.672 207.967 175.146C207.967 176.619 209.162 177.813 210.635 177.813C212.109 177.813 213.304 176.619 213.304 175.146C213.304 173.672 212.109 172.478 210.635 172.478Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M195.947 186.102C195.944 184.156 195.007 182.331 193.429 181.193C191.85 180.056 189.821 179.746 187.975 180.358C186.088 180.961 184.631 182.474 184.1 184.381C183.418 186.704 184.19 189.21 186.061 190.746C187.308 191.828 188.25 193.217 188.792 194.775L188.966 195.237C189.11 195.633 189.485 195.896 189.906 195.896C190.327 195.896 190.702 195.633 190.846 195.237L191.128 194.486C191.746 192.969 192.72 191.622 193.966 190.558C195.229 189.421 195.949 187.801 195.947 186.102V186.102Z",
    fill: "#055CC0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.905 183.433C188.431 183.433 187.236 184.627 187.236 186.101C187.236 187.574 188.431 188.768 189.905 188.768C191.379 188.768 192.573 187.574 192.573 186.101C192.573 184.627 191.378 183.433 189.905 183.433V183.433Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M223.607 427.262H255.368V417.513H234.233L222.103 422.666C221.174 422.987 220.529 423.834 220.467 424.815V424.815C220.467 426.166 221.873 427.262 223.607 427.262Z",
    fill: "#192335"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M266.057 427.262H297.819V417.513H276.682L264.551 422.666C263.621 422.986 262.975 423.834 262.913 424.815V424.815C262.916 426.166 264.323 427.262 266.057 427.262Z",
    fill: "#192335"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 117.005,
    y: 232.195,
    width: 196.759,
    height: 8.46004,
    fill: "#0134A0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 117.005,
    y: 232.195,
    width: 196.759,
    height: 8.46004,
    fill: "#0134A0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 262.707,
    cy: 293.384,
    rx: 11.2779,
    ry: 11.2747,
    fill: "#AB9AF7"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.001,
    cy: 291.152,
    rx: 13.3105,
    ry: 13.3068,
    fill: "#AB9AF7"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.181,
    cy: 291.156,
    rx: 13.3105,
    ry: 13.3068,
    fill: "#AB9AF7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M329.151 277.85L328.498 291.156L328.466 291.809C328.118 298.897 322.267 304.465 315.168 304.463H272.024C264.926 304.465 259.075 298.897 258.727 291.809L258.695 291.156L258.042 277.85L329.151 277.85Z",
    fill: "#AB9AF7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 104.497,
    y: 438.693,
    width: 183.705,
    height: 1.45232,
    fill: "#293F51"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 312.564,
    y: 438.693,
    width: 93.9003,
    height: 1.45232,
    fill: "#293F51"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 78.6348,
    y: 238.471,
    width: 369.923,
    height: 10.5681,
    fill: "#0134A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1299 427.827H90.873L109.557 257.465L110.543 248.074H100.154L86.1299 427.827V427.827Z",
    fill: "#0134A0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M409.057 248.074L410.043 257.465L428.727 427.827H433.47L419.447 248.074H409.057V248.074Z",
    fill: "#0134A0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6211,
    y: 427.069,
    width: 470.311,
    height: 1.45232,
    fill: "#293F51"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.715 195.9H256.052V192.521H240.715V195.9ZM255.752 195.6H241.017L241.016 192.823H255.752V195.6Z",
    fill: "#055CC0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M277.812 318.064L220.528 318.305L219.637 282.175L276.761 277.015L277.812 318.064V318.064Z",
    fill: "#658FDF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M226.808 214.348L302.131 229.09L301.013 240.683L297.059 240.684L291.216 240.683L224.271 240.702L226.808 214.348V214.348Z",
    fill: "#C9DEF6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M301.017 240.679L302.135 229.087L297.062 228.094V240.68L301.017 240.679V240.679Z",
    fill: "#C9DEF6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M279.786 156.241H315.322V117.333C315.321 105.498 305.725 95.9043 293.887 95.9037V95.9037C282.451 95.9037 272.056 104.879 271.503 116.294L270.064 146.035C269.935 148.695 270.901 151.292 272.738 153.22C274.575 155.149 277.123 156.24 279.786 156.241Z",
    fill: "#E6BBA6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.352 186.974H297.513C292.559 186.974 288.543 182.96 288.543 178.007V146.349H315.317V178.008C315.317 182.959 311.304 186.973 306.352 186.974V186.974Z",
    fill: "#E6BBA6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 301.931,
    cy: 173.589,
    rx: 13.3885,
    ry: 13.3847,
    fill: "#E6BBA6"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.768,
    cy: 293.384,
    rx: 11.2779,
    ry: 11.2747,
    fill: "#4A90E2"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.768,
    cy: 293.384,
    rx: 11.2779,
    ry: 11.2747,
    fill: "#658FDF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M257.516 418.157L239.654 292.74L209.535 294.506L228.61 418.157H257.516V418.157Z",
    fill: "#658FDF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M299.645 418.157L281.783 292.74L251.664 294.506L270.738 418.157H299.645V418.157Z",
    fill: "#658FDF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M335.199 277.85C335.205 282.41 334.327 286.929 332.614 291.156H266.676C261.309 277.862 264.456 262.645 274.657 252.569C284.858 242.492 300.116 239.529 313.348 245.055C326.581 250.581 335.197 263.513 335.199 277.85Z",
    fill: "#AB9AF7"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 299.643,
    cy: 277.85,
    rx: 9.75116,
    ry: 9.74844,
    fill: "#40327A"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375.065,
    cy: 227.337,
    rx: 13.3015,
    ry: 13.2978,
    transform: "rotate(-4.699 375.065 227.337)",
    fill: "#C9DEF6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M314.934 201.904L367.496 238.274L384.608 218.074L340.025 172.285L314.934 201.904V201.904Z",
    fill: "#C9DEF6"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.033,
    cy: 185.873,
    rx: 19.5018,
    ry: 19.4974,
    transform: "rotate(-18.744 326.033 185.873)",
    fill: "#C9DEF6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.028,
    cy: 239.362,
    rx: 7.799,
    ry: 7.79988,
    transform: "rotate(-56.899 314.028 239.362)",
    fill: "#FF95A9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M306.755 235.951C306.3 238.273 304.492 240.092 302.172 240.561C299.853 241.03 297.479 240.056 296.158 238.092C294.837 236.129 294.83 233.564 296.138 231.593C297.447 229.622 299.814 228.633 302.137 229.088C303.66 229.385 305.002 230.276 305.868 231.563C306.734 232.85 307.053 234.429 306.755 235.951V235.951Z",
    fill: "#FF95A9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M310.439 246.288L298.323 240.022L302.139 229.088L315.526 231.707L310.439 246.288V246.288Z",
    fill: "#FF95A9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M237.312 229.949C235.899 237.153 228.913 241.848 221.707 240.437C214.501 239.026 209.803 232.043 211.213 224.838C212.623 217.634 219.607 212.936 226.814 214.344C230.276 215.021 233.328 217.046 235.297 219.972C237.266 222.899 237.991 226.488 237.312 229.949V229.949Z",
    fill: "#C9DEF6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M284.363 201.891L231.842 238.32L214.706 218.139L259.239 172.301L284.363 201.891V201.891Z",
    fill: "#C9DEF6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M284.366 201.89L240.757 232.136L222.268 210.35L259.237 172.298L284.366 201.89V201.89Z",
    fill: "#C9DEF6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M314.934 201.904L358.575 232.102L377.041 210.296L340.03 172.285L314.934 201.904V201.904Z",
    fill: "#C9DEF6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.245,
    cy: 185.872,
    rx: 19.4974,
    ry: 19.5018,
    transform: "rotate(-71.334 273.245 185.872)",
    fill: "#C9DEF6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M339.964 180.692L335.196 277.847H264.09L259.322 180.692C259.139 176.961 260.494 173.318 263.071 170.612C265.647 167.906 269.221 166.375 272.958 166.375H326.328C330.065 166.375 333.639 167.906 336.216 170.612C338.793 173.317 340.147 176.961 339.964 180.692Z",
    fill: "#C9DEF6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M335.717 278.331L379.103 427.784H384.088L348.611 278.331H335.717V278.331Z",
    fill: "#0134A0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M290.35 278.331L246.965 427.784H241.979L277.455 278.331H290.35V278.331Z",
    fill: "#0134A0"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.033,
    cy: 257.013,
    rx: 73.0642,
    ry: 73.0438,
    fill: "#000B64"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M324.883 211.033H301.187C299.877 211.034 298.62 210.515 297.693 209.589C296.766 208.663 296.245 207.407 296.245 206.097V206.097C296.245 203.371 298.456 201.161 301.182 201.161H324.878C326.187 201.161 327.443 201.682 328.368 202.607C329.294 203.533 329.814 204.788 329.814 206.097V206.097C329.814 208.821 327.607 211.03 324.883 211.033V211.033Z",
    fill: "#C9DEF6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M266.78 98.7164V110.287C266.777 111.16 266.885 112.03 267.102 112.876H288.877V87.0389H278.462C275.364 87.0378 272.392 88.2678 270.201 90.4579C268.01 92.6481 266.78 95.6189 266.78 98.7164V98.7164Z",
    fill: "#8896AA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M326.03 128.879H303.644V92.2445H311.033C319.316 92.2445 326.03 98.9571 326.03 107.237V128.879Z",
    fill: "#8896AA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M268.45 110.396H291.598C300.645 110.386 307.977 103.056 307.987 94.0107C308.019 91.2084 306.541 88.6053 304.119 87.1949C301.697 85.7845 298.703 85.7845 296.28 87.1949C293.858 88.6053 292.381 91.2084 292.413 94.0107C292.412 94.4603 292.048 94.8247 291.598 94.8253H268.45V110.396Z",
    fill: "#8896AA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M276.72 102.609H288.725C291.528 102.64 294.132 101.164 295.543 98.7419C296.954 96.3202 296.954 93.3273 295.543 90.9056C294.132 88.4839 291.528 87.0071 288.725 87.0389H276.72C273.917 87.0071 271.314 88.4839 269.903 90.9056C268.492 93.3273 268.492 96.3202 269.903 98.7419C271.314 101.164 273.917 102.64 276.72 102.609Z",
    fill: "#8896AA"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M264.523 107.65C264.524 114.133 269.78 119.387 276.264 119.388C282.749 119.388 288.875 114.132 288.875 107.65C288.875 101.168 282.746 95.9118 276.264 95.9118C273.15 95.9118 270.164 97.1486 267.962 99.35C265.76 101.551 264.523 104.537 264.523 107.65Z",
    fill: "#8896AA"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 308.934,
    y: 116.443,
    width: 32.4469,
    height: 12.1643,
    transform: "rotate(-180 308.934 116.443)",
    fill: "#8896AA"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 308.001,
    y: 131.798,
    width: 25.0653,
    height: 15.5157,
    transform: "rotate(-180 308.001 131.798)",
    fill: "#8896AA"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M312.361 153.527H300.063C293.83 153.525 288.778 148.474 288.775 142.242V125.54H326.028V139.873C326.025 147.416 319.906 153.529 312.361 153.527V153.527Z",
    fill: "#8896AA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M288.775 125.959H283.612C278.445 125.959 274.255 121.77 274.255 116.604V111.994H288.775V125.959Z",
    fill: "#8896AA"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 283.614,
    y: 158.9,
    width: 34.9934,
    height: 10.9599,
    fill: "#C9DEF6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M282.935 137.508H277.094V125.831H282.935C286.16 125.831 288.775 128.445 288.776 131.669V131.669C288.776 134.894 286.16 137.508 282.935 137.508V137.508Z",
    fill: "#E6BBA6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.576,
    cy: 168.773,
    rx: 2.74948,
    ry: 2.74871,
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.446 168.771C149.446 170.498 150.845 171.898 152.572 171.899C154.299 171.898 155.699 170.499 155.701 168.773C155.701 167.046 154.301 165.646 152.574 165.646C150.847 165.646 149.447 167.045 149.446 168.771ZM150.203 168.774C150.202 167.465 151.263 166.403 152.572 166.402C153.882 166.402 154.944 167.463 154.946 168.773C154.946 170.082 153.885 171.143 152.575 171.144C151.266 171.144 150.204 170.083 150.203 168.774Z",
    fill: "#0134A0"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.576,
    cy: 179.204,
    rx: 2.74948,
    ry: 2.74871,
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.444 179.203C149.444 180.93 150.844 182.331 152.572 182.331C154.299 182.33 155.699 180.931 155.701 179.205C155.702 177.477 154.302 176.077 152.574 176.076C150.846 176.076 149.445 177.475 149.444 179.203ZM150.201 179.206C150.201 177.897 151.262 176.834 152.572 176.834V176.833C153.883 176.833 154.945 177.895 154.946 179.206C154.946 180.516 153.884 181.577 152.574 181.578C151.264 181.578 150.201 180.516 150.201 179.206Z",
    fill: "#055CC0"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.576,
    cy: 189.727,
    rx: 2.74948,
    ry: 2.74871,
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.444 189.725C149.444 191.452 150.844 192.853 152.572 192.853C154.299 192.852 155.7 191.453 155.701 189.726C155.701 187.999 154.301 186.599 152.573 186.598C150.845 186.598 149.445 187.998 149.444 189.725ZM150.201 189.729C150.2 188.419 151.262 187.357 152.572 187.356V187.355C153.883 187.356 154.945 188.417 154.946 189.727C154.947 191.037 153.885 192.099 152.574 192.1C151.264 192.1 150.201 191.039 150.201 189.729Z",
    fill: "#4A90E2"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.576,
    cy: 200.064,
    rx: 2.74948,
    ry: 2.74871,
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.444 200.063C149.444 201.79 150.844 203.191 152.572 203.192C154.299 203.19 155.7 201.791 155.701 200.064C155.701 198.337 154.301 196.937 152.573 196.936C150.845 196.936 149.445 198.336 149.444 200.063ZM150.201 200.067C150.2 198.757 151.262 197.695 152.572 197.694V197.693C153.883 197.694 154.945 198.755 154.946 200.065C154.947 201.375 153.885 202.437 152.574 202.438C151.264 202.438 150.201 201.377 150.201 200.067Z",
    fill: "#C9DEF6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.576,
    cy: 210.402,
    rx: 2.74948,
    ry: 2.74871,
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.444 210.402C149.444 212.129 150.844 213.529 152.572 213.53C154.3 213.529 155.7 212.129 155.701 210.401C155.701 208.674 154.3 207.274 152.572 207.275C150.845 207.275 149.445 208.675 149.444 210.402ZM150.201 210.405C150.2 209.095 151.262 208.033 152.572 208.032V208.03C153.883 208.031 154.945 209.093 154.946 210.403C154.947 211.713 153.885 212.776 152.574 212.776C151.264 212.777 150.201 211.715 150.201 210.405Z",
    fill: "#E1E1E1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M163.87 67.0513C163.867 65.106 162.93 63.2804 161.352 62.1433C159.773 61.0062 157.744 60.6958 155.897 61.3089C154.011 61.9124 152.555 63.4245 152.023 65.3321C151.341 67.6545 152.113 70.1597 153.984 71.6961C155.231 72.7777 156.173 74.1672 156.715 75.7262L156.889 76.188C157.033 76.5833 157.408 76.8465 157.829 76.8465C158.25 76.8465 158.625 76.5833 158.769 76.188L159.051 75.4363C159.669 73.9193 160.643 72.5726 161.889 71.5092C163.151 70.3709 163.871 68.7507 163.87 67.0513Z",
    fill: "#055CC0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M157.824 64.3835C156.35 64.3835 155.155 65.5779 155.155 67.0513C155.155 68.5247 156.35 69.719 157.824 69.719C159.298 69.719 160.492 68.5247 160.492 67.0513C160.492 65.5782 159.297 64.3841 157.824 64.3835V64.3835Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M310.093 67.0513C310.09 65.106 309.153 63.2804 307.575 62.1433C305.996 61.0062 303.967 60.6958 302.12 61.3089C300.233 61.9122 298.776 63.4242 298.244 65.3321C297.563 67.6547 298.335 70.1595 300.206 71.6961C301.453 72.7777 302.395 74.1672 302.937 75.7262L303.111 76.188C303.255 76.5833 303.63 76.8465 304.051 76.8465C304.472 76.8465 304.847 76.5833 304.991 76.188L305.273 75.4363C305.891 73.9193 306.865 72.5726 308.111 71.5092C309.374 70.371 310.094 68.7508 310.093 67.0513Z",
    fill: "#C9DEF6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M304.05 64.3835C302.577 64.3841 301.382 65.5787 301.383 67.052C301.383 68.5252 302.578 69.7192 304.052 69.719C305.525 69.7189 306.72 68.5245 306.72 67.0513C306.72 66.3436 306.439 65.6649 305.938 65.1646C305.437 64.6642 304.758 64.3833 304.05 64.3835Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M263.817 108.282H237.092L236.989 108.203L210.756 87.6746L197.652 97.9268H184.159L184.056 97.8469L157.692 77.2165H144.718L131.357 87.6746L104.76 66.8614H91.6562V66.1057H105.02L105.124 66.1857L131.357 86.7151L144.458 76.4619H157.952L158.055 76.5408L184.419 97.1712H197.392L210.756 86.7151L237.352 107.527H263.558L276.687 97.2511L277.154 97.8469L263.817 108.282V108.282Z",
    fill: "url(#paint1_linear_55_20737)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M242.888 98.5195C242.885 96.5743 241.948 94.7486 240.369 93.6115C238.791 92.4744 236.762 92.1641 234.915 92.7772C233.029 93.3807 231.572 94.8927 231.04 96.8003C230.359 99.123 231.131 101.628 233.002 103.164C234.249 104.246 235.191 105.636 235.733 107.194L235.907 107.656C236.051 108.052 236.426 108.315 236.847 108.315C237.268 108.315 237.643 108.052 237.787 107.656L238.069 106.905C238.687 105.388 239.661 104.041 240.907 102.977C242.169 101.839 242.889 100.219 242.888 98.5195V98.5195Z",
    fill: "#055CC0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M236.844 95.8558C235.371 95.8563 234.176 97.051 234.177 98.5242C234.177 99.9974 235.372 101.191 236.846 101.191C238.319 101.191 239.514 99.9968 239.514 98.5235C239.514 97.8158 239.232 97.1371 238.732 96.6368C238.231 96.1365 237.552 95.8555 236.844 95.8558Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_20737",
    x1: 180.963,
    y1: 139.74,
    x2: 330.088,
    y2: 139.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#4A90E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A90E2",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_55_20737",
    x1: 91.6562,
    y1: 108.282,
    x2: 277.154,
    y2: 108.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8896AA",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642,
    stopColor: "#8896AA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFte2);
export default __webpack_public_path__ + "static/media/FTE2.7e66b02ceedb8ac014ee6620da648e6c.svg";
export { ForwardRef as ReactComponent };